import { render } from "./SubMenu2.vue?vue&type=template&id=dd1cbe66"
import script from "./SubMenu2.vue?vue&type=script&lang=js"
export * from "./SubMenu2.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__